module.exports = __webpack_public_path__ + "assets/img/48.902fa921.jpg";